import React, { useEffect, useMemo, useState } from 'react';

import { useTranslation } from 'react-i18next';

import PageWithHeader from 'layouts/PageWithHeader/PageWithHeader';
import { TableComponent } from 'components';
import { TableData, TableParams, TableRow } from 'types/other';
import { SearchPlanogramResponse } from 'types';
import { planogramsModel } from 'models';
import { DEFAULT_TABLE_PARAMS } from 'components/TableComponent/constants';

const NOT_CHANGED_STATUS = 304;


export const SearchPlanograms = () => {
  const { t } = useTranslation();

  const [data, setData] = useState<SearchPlanogramResponse>({
    resultsData: [],
    planogramVersionsCount: 0,
  });

  const [tableParams, setTableParams] = useState<TableParams>({
    ...DEFAULT_TABLE_PARAMS,
  });

  const pageData = useMemo(() => {
    const start = tableParams.perPage * tableParams.page;
    const end = start + tableParams.perPage;

    return data.resultsData.slice(start, end)
  }, [data, tableParams]);

  const tableData = useMemo<TableData>(() => ({
      headers: ['Client', 'Name', 'Id'],
      rows: pageData.map<TableRow>(it => ({
          cells: [<>{it.clientName}</>, <>{it.planogramName}</>, <>{it.id}</>],
      })),
    }), [pageData]);

  const search = tableParams.search ?? '';

  useEffect(() => {
    planogramsModel.searchPlanograms(search).then(response => {
      if (response.status === 200) setData(response.data);
      else if (response.status !== NOT_CHANGED_STATUS) {
        throw new Error(response.statusText);
      }
    });
  }, [search]);

  return (
    <PageWithHeader tabTitle={t('pages.searchPlanograms.title')} headerText={t('pages.searchPlanograms.title')}>
        <TableComponent
            data={tableData}
            count={data.planogramVersionsCount}
            tableParams={tableParams}
            onParamsChange={params => setTableParams({...tableParams, ...params})}
            enableSearch
        />
    </PageWithHeader>
  );
};
